import Vue from 'vue'
/*
使用方法，v-intervalclick="handleclick"
或者：v-intervalclick="{func:handleclick,data:参数,wait:1000}"
data和wait选填
*/
Vue.directive('intervalclick', function (el, binding) {
  let timeout
  el.addEventListener('click', function () {
    let fn = typeof binding.value === 'function' ? binding.value : (binding.value.func || null)
    if (!fn) {
      throw new Error('没有设置func参数')
    }
    let { data } = binding.value
    let wait = 500 || binding.value['time']
    // 第一次立即执行（如果没有定时器立即执行）
    if (!timeout) {
      fn(data)
    }
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(function () {
      timeout = null // 定时器结束之后清空定时器
    }, wait)
  })
})
